(ns web3.components.intercom
  (:require [web3.env :as env]
            [web3.view :as v]
            [re-frame-simple.db :as db]
            [web3.utils :as utils]
            [web3.constants :as constants]
            [web3.routing.core :as routing]
            [re-frame.core :as rf]
            [clojure.string :as str]
            [web3.ui-state :as ui-state]
            [web3.view.hiccup :as hiccup]))

(def icon
  [:svg
   {:width "98px", :height "98px", :view-box "0 0 98 98", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:fill "currentColor", :fill-rule "nonzero"}
     [:path
      {:d "M86.5,30.7 L76.21,30.7 L76.21,12.7 C76.1989757,5.96279416 70.7372126,0.505504249 64,0.5 L13,0.5 C9.75559182,0.492033902 6.64119172,1.7746041 4.34329318,4.0649993 C2.04539464,6.3553945 0.752645227,9.46558312 0.75,12.71 L0.75,54 C0.757946735,57.2409485 2.05303482,60.3459983 4.35035758,62.6320689 C6.64768034,64.9181394 9.75905152,66.1979663 13,66.19 L19.13,66.19 L19.13,80.19 C19.1281884,81.2025444 19.7373144,82.1161924 20.6726836,82.5039215 C21.6080528,82.8916507 22.684929,82.6768842 23.4,81.96 L39.1,66.19 L42.1,66.19 L42.1,72.77 C42.1054056,78.68533 46.8847595,83.4870173 52.8,83.52 L65.14,83.52 L78.41,96.77 C79.125071,97.4868842 80.2019472,97.7016507 81.1373164,97.3139215 C82.0726856,96.9261924 82.6818116,96.0125444 82.68,95 L82.68,83.52 L86.5,83.52 C92.434776,83.514487 97.244487,78.704776 97.25,72.77 L97.25,41.45 C97.244487,35.515224 92.434776,30.705513 86.5,30.7 Z M38.06,61.19 C37.3965057,61.188815 36.7597537,61.4514303 36.29,61.92 L24.09,74.11 L24.09,63.69 C24.09,63.0269588 23.8266079,62.391074 23.357767,61.922233 C22.888926,61.4533921 22.2530412,61.19 21.59,61.19 L13,61.19 C11.0843291,61.2006353 9.24318187,60.4484552 7.88296033,59.0994906 C6.52273878,57.7505261 5.75528449,55.9156931 5.75,54 L5.75,12.71 C5.74997047,10.7908384 6.51508168,8.95085872 7.87588257,7.59756569 C9.23668347,6.24427267 11.080868,5.48935278 13,5.5 L64,5.5 C67.981973,5.5 71.21,8.72802695 71.21,12.71 L71.21,54 C71.1989759,57.9741603 67.9741756,61.1900153 64,61.19 L38.06,61.19 Z M92.25,72.77 C92.25,75.9456373 89.6756373,78.52 86.5,78.52 L80.18,78.52 C78.7992881,78.52 77.68,79.6392881 77.68,81.02 L77.68,89.02 L67.94,79.3 C67.4702463,78.8314303 66.8334943,78.568815 66.17,78.57 L52.8,78.57 C51.2576541,78.583471 49.7745615,77.9767281 48.6839167,76.8860833 C47.5932719,75.7954385 46.986529,74.3123459 47,72.77 L47,66.19 L64,66.19 C70.7333177,66.1845102 76.193472,60.7332996 76.21,54 L76.21,35.7 L86.5,35.7 C89.6756373,35.7 92.25,38.2743627 92.25,41.45 L92.25,72.77 Z"}]
     [:circle {:cx "32.76", :cy "33.2", :r "2.5"}]
     [:circle {:cx "21.3", :cy "33.2", :r "2.5"}]
     [:circle {:cx "44.21", :cy "33.2", :r "2.5"}]
     [:circle {:cx "55.66", :cy "33.2", :r "2.5"}]]]])

(defn handle-unread-count-change [n]
  (db/dispatch [:update :db/intercom merge {:unread-count n
                                            :transition :bounce}])
  (utils/wait 500
              (db/dispatch [:update :db/intercom dissoc :transition])))

(defn init []
  (set! (.-intercomSettings js/window)
        #js {:app_id (env/config :INTERCOM_APP_ID)
             :alignment "left"
             :hide_default_launcher true})

  (js/Intercom "onShow"
               (fn []
                 ;; ensure that intercom is added to path no matter how it is opened
                 (routing/nav! (routing/path-for :router/intercom "/"))))

  (js/Intercom "onHide"
               (fn []
                 ;; remove intercom from path whenever it is hidden
                 (routing/nav! (routing/path-for :router/intercom nil))
                 (db/dispatch [:assoc-in [:db/intercom :transition] :out])
                 (utils/wait 300
                             (db/dispatch [:assoc-in [:db/intercom :active?] false]))))

  (js/Intercom "onUnreadCountChange" handle-unread-count-change)
  (when (= "centriq" (:partner/id env/config))
   (db/dispatch [:assoc-in [:db/intercom :initialized?] true])) ;;boot the app with intercom badge active
  )

(defn show!
  "Show the Intercom messenger. Optionally pass in a default message."
  [& [message]]
  (when-not (db/get-in [:db/intercom :active?])
    (db/dispatch [:update :db/intercom merge {:active? true
                                              :initialized? true
                                              :transition nil}])
    (if (string? message)
      (js/Intercom "showNewMessage" message)
      (js/Intercom "show"))))

(rf/reg-fx :intercom/show show!)

(def last-id (atom nil))
(defn update-user! [{:keys [id email firstName lastName]}]
  (assert (and id email))

  ;; only run when id has changed
  (when-not (= id @last-id)

    (reset! last-id id)
    (js/Intercom "update" #js {:user_id id
                               :email email
                               :name (str/join " " (keep identity [firstName lastName]))})))

(rf/reg-fx :intercom/update-route
           (fn []
             ;; wait a bit to make sure the route has been set.
             ;; there is absolutely no urgency, this is just to set the correct route
             ;; in case a user initiates an Intercom conversation.
             (js/setTimeout #(js/Intercom "update") 300)))

(rf/reg-fx :intercom/shutdown
           (fn []
             (js/Intercom "shutdown")))

(v/defview route-trigger
  ;; placeholder to ensure that intercom state is initialized
  ;; when router is active
  {:component-did-mount #(show!)}
  [])

(defn badge []
  (let [{:keys [active?
                initialized?
                transition
                unread-count]} (db/get :db/intercom)
        mobile? (ui-state/mobile?)
        initialized? (or initialized? (some-> unread-count (pos?)))]
    [:<>
     (when (db/get-in [:db/routers :router/intercom])
       [route-trigger])
     (when-not mobile?
       [:div.fixed.left-0.bottom-0.pad-left-3.pad-bottom-3.hover-bottom-5
        {:class (when (= transition :bounce) "transition-bounce")
         :style {:visibility (if (and initialized? (not active?)) "visible" "hidden")
                 :opacity (if (or (not initialized?) active?) 0 1)
                 :transition "all 0.2s ease"
                 :z-index (:intercom-badge constants/z-index)}}
        [:div.bg-black.text-white.cursor-pointer.relative.round-100p.flex.items-center.justify-center
         {:on-click show!
          :style {:width 65
                  :height 65
                  :box-shadow "2px 2px 5px rgba(0,0,0,0.2)"}}
         (hiccup/size icon 32)
         (when (some-> unread-count (pos?))
           [:div.absolute.top-0.right-0.bg-blue.pad-all-1.round-100p.text-size-12.weight-bold
            unread-count])]])]))

(comment
  ;; run from REPL to demonstrate `bounce` animation when unread count changes
  (handle-unread-count-change (rand-int 100)))